module.exports = __webpack_public_path__ + "img/img49.3763f981.svg";